import { Button, Col, Row, Modal, Tooltip, Divider, Collapse } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import { ReactComponent as Informa } from '../../../../assets/images/svg/i_information_fill.svg';
import { ReactComponent as Plus_Icon } from '../../../../assets/images/svg/Plus_icon.svg';
import { ReactComponent as Add_Plus_Icon } from '../../../../assets/images/svg/Plus_Icon_Blue.svg';
import React, { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import * as actions from '../../../../store/actions/fileAction';
import './buddhimedFileUpload.less';

import ApplicationDetail from '../../../services/applicationDetail.service';
import {
  getFileUploadStatus, getIsPageNameDetail, getNonAvailableClassification, getValue, getIsInitialSettlement, panValidationUpload,
  getIsPageNameNewAdmission,
  customGTMEvent,
  getMaxFileSizeMessage,
  getIsPageNameEdit,
  clearFormFieldsByQuestionText,
  isRemarksFieldRequired,
  sortOnDate,
  getCancelModalTitle,
  getPayerConfigPropValue,
  getFlowSpecificRemarkLength,
  handleUserFocus,
  setPanFieldInBuddhimedFromHIS,
} from '../../../../modules/crm/inPatient/service/crmUtils';
import { GLOBAL_URL } from '../../../constants/dataServiceUrl';
import { RootState } from '../../../../store';
import {
  setbillAmountArray,
  setClassificationArray, setIsComeFromSubmit, setIsFileProcessInProgress,
  setNonAvailableClassification, setPercent, setUploadedFiles,
  updateDefaultTimeline, printClaimPDF, setPanField, setPanRequired, setModalSwitch, downloadDocumentGuids,
  setFinalMandatoryClassifications,
  // setToggleClick,
  // setMobileOnScreen,
} from '../../../../store/actions/newAdmissionAction';
import {
  EXTENDED_STATUS, FILE_CHECKBOX_SELECTION, FILE_UPLOAD_QUERY, fileTextMessage, mandatoryClassificationInfo, MAX_FILE_LIMIT_COUNT,
  MB2Bytes,
  NEW_UPLOAD_STATUS, PAN_MANDATORY, progress, UPLOAD_STATUS, ABHI_INITIALDISCHARGE,
  HIS_UPLOAD_STATUS,
  formInputStates,
  INCLUDE_OLD_DOCS_LABEL,
} from '../../../constants/crmConstants';
// import { ReactComponent as UploadIcon } from '../../../../assets/images/svg/drive_folder_upload.svg';
import InformationSection from '../InformationSection';
import { withRouter } from 'react-router-dom';
import {
  CANCELLATION_STATUS_ID, CANCEL_TEXT, COMMON_ERROR, getFlowName,
  getPrefixforRemark, FALL_BACK_CANCEL_MODAL_NAME, GUTTOR_SPACE,
} from '../../../constants/commonConstants';
import { useCallBuddhimed } from '../../../hooks/useCallBuddhimed';
import Text from 'antd/lib/typography/Text';
import { centeredNotification, getMinFileCount, isNonIntegratedPayer, sortByUid } from '../../../../utils/utility';
import { cloneDeep, isEmpty } from 'lodash';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import FormTextArea from '../../crmFormElement/FormTextArea/FormTextArea';
import FormSwitch from '../../crmFormElement/FormSwitch/FormSwitch';
import FormTextInput from '../../crmFormElement/FormInputText/FormInputText';
import { requiredDocuments } from '../../../constants/crmConstants';
import PanelCollapse from '../../collapse/PanelCollapse';
import DiscrepencyClassificationQuestion from '../DiscrepencyClassificatonQuestion';
import { ReactComponent as InformationIcon } from '../../../../assets/images/svg/i_new_info_icon.svg';
import { ReactComponent as CrossIcon } from '../../../../assets/images/svg/Cross_Icon_Filled.svg';
import HisDescrepencyQuestion from '../HisDicrepencyQuestion';
import { hisFileBeforeUpload, getMimeTypeFromExtension } from '../../../../utils/fileUploadUtils';
import NonHisBuddhiMedUploadListItem from '../NonHisBuddhimedUploadListItem';
import FileCount from './FileCount';
import NonHisFileCountHeader from './NonHISFileCountHeader';
import HISAvailableUploadListItem from '../HISAvailableUploadListItem';
import { getISTDateWithTimeSeconds } from '../../../../utils/dateTimeUtils';

const BuddhiMedFileUpload = ({ form, location: { pathname }, showDragger, admissionForm, remarkRemoved = false, isCancel, queryFlow,
  callBuddhimed = true, showPreviouslyAddedFiles = true, setErrMsgFromDeleteClaim = (): void => { },
  cancelFlow, isSettlement = false, formTitle }: any,
): ReactElement => {
  const appDetail = ApplicationDetail.instance;
  const ALLOWED_FILE_EXTENSIONS = ApplicationDetail.instance.getAllowedFileExtension();
  const isDocumentEnabledChecklist = ApplicationDetail.instance.getIsDocumentChecklistEnabled();
  const dispatch = useDispatch();
  const isPageNameDetail = getIsPageNameDetail(pathname);
  const isEditPage = getIsPageNameEdit(pathname);
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const mounted = useRef(false);
  const [pdfPreview, setpdfPreview] = useState(false);
  const [testPdf, setTestPdf] = useState('');
  const [panMandatory, setPanMandatory] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [showExistingUploadFlow, setShowExistingUploadFlow] = useState(true);
  const [showNewUploadFlow, setShowNewUploadFlow] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState('');
  const [isValidFile, setIsValidFile] = useState(false);
  const [inputStates, setInputStates] = useState(formInputStates.buddhimedFileUploadForm);
  const {
    // toggleClick,
    uploadedFiles: fileList, classificationArray, nonAvailableClassification, isComeFromSubmit, isDischargeCase,
    additionalMandatoryDocuments, billAmountArray, maximumFileSizeAllowed, admissionFormVal, isMinimize, panCardNumber, panRequired,
    isDraftSelected, percent: filesUploadedPercentage, isFileProcessInProgress, uploadedFiles, showProbability, selectedDraft,
    downloadDocumentGuidList, finalMandatoryClassifications, openFileDialogOnClick, selectedFiles, isDaycareCase,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { claimDetails, mandatoryClassifications: claimDetailClassifications, isCashlessSubmit } =
    useSelector((state: RootState): any => state.admissionDetails);
  const { selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const { patientDetails } = selectedPatientDetail || {};
  const { nextAllowStatus = [], oldDocsAllowed, hospActionId, isQuery, isDischargeContestCTA } = claimDetails || { nextAllowStatus: [] };
  const [status] = nextAllowStatus;
  const { kycPan } = admissionFormVal?.customerDetail || {};
  const draftkycPan = panCardNumber;
  const { payerLookUp, payerList: { payer, formControlConfig } } = useSelector((state: RootState): any => state);
  const { id: payerId, productCode, uniqueIdentifier, isDCAllowed = {},
    shortName, totalFileSizeInMB, maxFileCount,
    isInitialDischargeEnabledPayer, isRpaPayer, isOnMailPayer, actionProperties,
  } = payer;
  const [buddhimedReqQueue, setBuddhimedReqQueue] = useState<any[]>([]);
  const [nonAvlclass, setNonAvlclass] = useState<any[]>([]);

  const defaultTimeline = useSelector((state: RootState): any => state?.newAdmission?.defaultTimeline || {});
  const isInitialSettlement = getIsInitialSettlement(pathname);
  const [mandatoryClassifications, setMandatoryClassifications] = useState([] as any);
  const payerConfigValues = Object.values(formControlConfig);
  const fileCountObject = JSON.parse(totalFileSizeInMB || '{}');
  const nextStatus = !isCancel ? (nextAllowStatus[0] || 'NEWADMISSION') : '';
  const totalFileSizeInNumber = fileCountObject[nextStatus];
  const maxFileCountObject = JSON.parse(maxFileCount || '{}');
  const numberOfFilesLimit = maxFileCountObject[nextStatus] || 50;
  const fileSize = JSON?.parse(payer?.allowedFileSizeInMB || '{}');
  const buddhimedCall = useCallBuddhimed(payerConfigValues);
  const fileSizeForNextStatus = fileSize?.[nextStatus];
  const minPropObj = payerConfigValues?.filter(({ MIN }: any): boolean => MIN);
  const maxPropObj = payerConfigValues?.filter(({ MAX }: any): boolean => MAX);

  // const payerConfigValues = Object.values(formControlConfig);
  const cancelActionProperty = JSON.parse(actionProperties || '{}')?.[CANCELLATION_STATUS_ID];
  const getRequiredDocuments = (entity: any): any => {
    const foundEntity: any = requiredDocuments?.find((obj: any): any => entity in obj);
    return foundEntity ? foundEntity[entity] : [];
  };

  const documentsTobeSubmitted = getRequiredDocuments(shortName); // to get the required files according to the payer from constant file
  // Reverting the changes for optional pan on prod
  const optionalReq = payerConfigValues?.filter(({ type }: any): boolean => type === 'PanCardFieldPresent').length;
  const isQueryFlow = isQuery && isEditPage;
  const nextFlowStatus = nextStatus || CANCEL_TEXT;
  const minLengthValue = getFlowSpecificRemarkLength(getPayerConfigPropValue(minPropObj, 'minLength', 'Remarks'), nextFlowStatus);
  const maxLengthValue = getFlowSpecificRemarkLength(getPayerConfigPropValue(maxPropObj, 'maxLength', 'Remarks'), nextFlowStatus);
  const fieldLengthValue = [
    minLengthValue || undefined,
    maxLengthValue || undefined,
  ];

  useEffect((): void => {
    if (!isMinimize && (kycPan || draftkycPan)) {
      const panFieldValue = kycPan || draftkycPan;
      form?.setFields([{
        name: 'panNumber',
        value: kycPan || draftkycPan,
      }]);
      dispatch(setPanField(panFieldValue));

    }
    if (isDischargeCase || status === 'DISCHARGE' || isCashlessSubmit) {
      dispatch(setPanRequired(true));
    }
    if (panRequired) {
      setPanMandatory(true);
    } else {
      setPanMandatory(false);
    }
  }, [isMinimize, panRequired, status, isCashlessSubmit]);

  useEffect((): void => {
    setPanFieldInBuddhimedFromHIS(patientDetails, optionalReq > 0, form, dispatch, setPanField);
  }, [selectedPatientDetail]);

  useEffect((): any => {
    if (!isDraftSelected) {
      const panPrefilledData = claimDetails?.panCardNumber;
      if (panPrefilledData !== null) {
        form?.setFields?.([{
          name: 'panNumber',
          value: panPrefilledData,
        }]);
        dispatch(setPanField(panPrefilledData));

      }
    }
  }, [claimDetails]);

  const parsedDraftData = selectedDraft?.rawDraft?.length > 0 ? JSON?.parse(selectedDraft?.rawDraft) : {};

  useEffect((): any => {
    if (showProbability === 0 || (isCashlessSubmit && payer.shortName === 'SHAI' && isNonIntegratedPayer(isRpaPayer, isOnMailPayer))) {
      setMandatoryClassifications(
        !status ?
          payerLookUp[uniqueIdentifier]?.mandatoryClassificationName || [] :
          claimDetailClassifications[isDischargeCase ? 'DISCHARGE' : status] || []);
      dispatch(setFinalMandatoryClassifications([]));
    }
  }, [uniqueIdentifier, status, showProbability]);

  useEffect((): any => {
    setFileErrorMessage('');
  }, [payer]);

  useEffect((): any => {
    const newFileUploads = fileList?.filter((file: any): any => (file?.claimStatus === NEW_UPLOAD_STATUS ||
      file?.availableDocument === true));
    if (newFileUploads?.length < numberOfFilesLimit) {
      setFileErrorMessage('');
    }
  }, [selectedFiles]);

  useEffect((): any => {
    if (payer?.showOtherBuddhimedFlow && showProbability > 0) {
      setMandatoryClassifications
        (payerLookUp[uniqueIdentifier]?.otherMandatoryClassification || []);
    }
  }, [payer, payerLookUp, showProbability]);

  useEffect((): any => {
    if (payer?.showOtherBuddhimedFlow && isDraftSelected && payerLookUp[uniqueIdentifier]?.otherMandatoryClassification === undefined) {
      const keys = Object?.keys(mandatoryClassificationInfo);
      const nonavlClass = parsedDraftData?.nonAvailableClassification?.map((obj: any): any =>
        keys?.find(
          (key: any): any =>
            mandatoryClassificationInfo[key]?.questionType?.toLowerCase() === obj?.questionType?.toLowerCase(),
        ),
      );

      setMandatoryClassifications(nonavlClass);
    }
  }, [isDraftSelected, uploadedFiles]);

  // This prevents unnecessary re-renders or effect re-runs due to object reference changes
  const classificationDependencies = useMemo((): any => ({
    mandatoryClassifications,
    additionalMandatoryDocuments,
  }), [mandatoryClassifications, additionalMandatoryDocuments]);

  useEffect((): void => {
    const {
      mandatoryClassifications: mandatoryClassificationsList,
      additionalMandatoryDocuments: additionalMandatoryDocumentsList,
    } = classificationDependencies;

    // During cancellation flow the useEffect is running and mandatory question are populated
    if ((!isEmpty(mandatoryClassificationsList) || !isEmpty(additionalMandatoryDocumentsList)) && !isCancel) {
      const classificationArr = (
        isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0
          ? mandatoryClassificationsList
          : (mandatoryClassificationsList || []).concat(additionalMandatoryDocumentsList)
      )
        .map((name: string): any => cloneDeep(mandatoryClassificationInfo[name]))
        .filter((classification: any): boolean => classification);
      // Resetting the Mandatory Questions field if the mandatory questions are reset
      clearFormFieldsByQuestionText(form, classificationArr);
      dispatch(setNonAvailableClassification(classificationArr));
      dispatch(setFinalMandatoryClassifications(classificationArr));
    }
  }, [classificationDependencies]);

  useEffect((): void => {
    const newUploadedFiles = (fileList?.[fileList?.length - 1]?.claimStatus === 'New uploads' ||
      fileList?.[fileList?.length - 1]?.existingRecord === false);
    let filesUploaded = false;
    filesUploaded = fileList?.every((ele: any): any => ele?.status === 'done');
    // Close modal when minimized or all files have been uploaded
    if (!isMinimize) {
      if (fileList?.length < numberOfFilesLimit) {
        if (fileList?.length > 0 && newUploadedFiles === true && filesUploaded) {
          dispatch(setModalSwitch(false));
        } else {
          dispatch(setModalSwitch(true));
        }
      } else {
        dispatch(setModalSwitch(false));
      }
    }
  }, [isMinimize, fileList, filesUploadedPercentage, mandatoryClassifications]);

  useEffect((): void => {
    // Calculate total size of newly uploaded files
    const totalUploadedFilesSize = fileList
      ?.filter((file: any): boolean => file?.claimStatus === NEW_UPLOAD_STATUS)
      ?.reduce((acc: number, file: any): any => acc + (file?.size || 0), 0);

    let newFileUploads = fileList?.filter((file: any): boolean => (file?.claimStatus === NEW_UPLOAD_STATUS ||
      file?.claimStatus === HIS_UPLOAD_STATUS || file?.existingRecord === false) && file?.status === UPLOAD_STATUS.done);
    newFileUploads = sortOnDate(newFileUploads, ['uploadedOn', 'createdDate']);

    const existingFiles = fileList?.filter((file: any): boolean => (file?.claimStatus !== NEW_UPLOAD_STATUS &&
      file?.claimStatus !== HIS_UPLOAD_STATUS) && file?.existingRecord === true);

    // Validation to check the maximum number of files uploaded
    if (numberOfFilesLimit && newFileUploads?.length > numberOfFilesLimit) {
      setFileErrorMessage(`Maximum file allowed is ${numberOfFilesLimit}`);
      setIsValidFile(false);
      // keep only the last allowed number of files
      const newFileList = newFileUploads?.slice((newFileUploads?.length - numberOfFilesLimit), newFileUploads?.length);
      dispatch(setUploadedFiles([...newFileList, ...existingFiles]));
    }

    // Validation to check the total size of uploaded files
    // Prevent multiple updates if the file size limit has already been exceeded
    if (totalFileSizeInNumber && totalUploadedFilesSize > totalFileSizeInNumber * MB2Bytes) {
      setFileErrorMessage(getMaxFileSizeMessage(totalFileSizeInNumber));
      setIsValidFile(false);
      const newFileList = newFileUploads?.slice(1, newFileUploads?.length);
      dispatch(setUploadedFiles([...newFileList, ...existingFiles]));
    }
  }, [fileList, selectedFiles]);

  const onSuccessBuddimedDetail = (uploadedDetails: any, file: any): void => {
    const callType = getValue(uploadedDetails, '[0].callType');
    const availableDocumentType = getValue(uploadedDetails, '[0].classification.availableDocumentType');
    const transactionId = getValue(uploadedDetails, '[0].classification.transactionId');
    const documentTypes = getValue(uploadedDetails, '[0].classification.documentTypes');
    const isClassification = String(callType).toUpperCase() === 'CLASSIFICATION';
    const finalAmount = getValue(uploadedDetails, '[0].finalAmount');
    const isbillClassification = String(callType).toUpperCase() === 'AI_BILL_SUBMISSION';
    if (isbillClassification) {
      file['finalAmount'] = finalAmount;
      billAmountArray.unshift({
        finalAmount,
        fileId: getValue(uploadedDetails, '[0].fileGuid'),
      });
    }
    if (isClassification) {
      file['fileType'] = availableDocumentType || [];
      file['transactionId'] = transactionId;
      file['documentTypes'] = documentTypes;
      const nonAvailableClass = getNonAvailableClassification(finalMandatoryClassifications, fileList, nonAvailableClassification);
      if (nonAvailableClass?.length > 0) {
        nonAvailableClass.map(({ questionType, questionText, attemptId }: any): any => {
          classificationArray.unshift({
            questionType,
            questionText,
            answer: null,
            tempId: `${file?.uid}${questionType}`,
            isDeleted: false,
            discrepancy: false,
            isRejected: false,
            availableDocumentType: JSON.stringify(availableDocumentType),
            fileId: getValue(uploadedDetails, '[0].fileGuid'),
            fileName: getValue(uploadedDetails, '[0].fileName'),
            attemptId: attemptId.toString(),
            answerOn: moment.default().format(),
            documentTypes, transactionId,
          });
          return classificationArray;
        });
      } else {
        classificationArray.unshift({
          tempId: `${file?.uid}`,
          isDeleted: false,
          discrepancy: false,
          isRejected: false,
          availableDocumentType: JSON.stringify(availableDocumentType),
          fileId: getValue(uploadedDetails, '[0].fileGuid'),
          fileName: getValue(uploadedDetails, '[0].fileName'),
          answerOn: moment.default().format(),
          documentTypes, transactionId,
        });
      }
    }
    const guid = getFileGuid(file);
    const findFile = fileList.find((currFile: UploadFile): boolean => {
      const fileGUID = getValue(currFile, 'response.uploadedDetails[0].fileGuid');
      return fileGUID === guid;
    });
    findFile.extendedStatus = availableDocumentType?.length ? EXTENDED_STATUS.verified : EXTENDED_STATUS.uploaded;

    findFile['fileType'] = availableDocumentType || [];

    if (mounted.current) {
      dispatch(setUploadedFiles([...fileList]));
    }

    if (mounted.current) {
      dispatch(setUploadedFiles([...fileList]));
      dispatch(setClassificationArray(classificationArray));
      dispatch(setbillAmountArray(billAmountArray));
    }
  };

  const onErrorBuddimedDetail = (file: UploadFile): void => {
    const selectedFile = fileList?.find(({ uid }: UploadFile): boolean => uid === file.uid);
    selectedFile.extendedStatus = EXTENDED_STATUS.uploaded;
    dispatch(setUploadedFiles([...fileList]));
  };

  const getFileGuid = (file: UploadFile): string => {
    return getValue(file, 'response.uploadedDetails[0].fileGuid');
  };

  useEffect((): any => {
    const nonStartedReqFile = buddhimedReqQueue.find(({ buddhimedReqStart }: any): boolean => !buddhimedReqStart);
    if (!nonStartedReqFile) {
      return;
    }

    const selectedFile = fileList?.find(({ uid }: UploadFile): boolean => uid === nonStartedReqFile.uid);
    if (selectedFile?.status !== UPLOAD_STATUS.done) {
      return;
    }
    nonStartedReqFile.buddhimedReqStart = true;
    setBuddhimedReqQueue([...buddhimedReqQueue]);

    if (!buddhimedCall.shouldCall()) {
      selectedFile.extendedStatus = EXTENDED_STATUS.verified;
      dispatch(setUploadedFiles([...fileList]));
      return;
    }

    selectedFile.extendedStatus = EXTENDED_STATUS.verifying;
    dispatch(setUploadedFiles([...fileList]));

    const request = { FileGuIDs: [getFileGuid(nonStartedReqFile)], payerId, productCode, hospActionId };
    dispatch(actions.getBuddimedDocumentTypes(
      request,
      (response: any): any => { onSuccessBuddimedDetail(response, nonStartedReqFile); },
      (): any => { onErrorBuddimedDetail(selectedFile); },
    ));

  }, [fileList, buddhimedReqQueue]);

  // checking condition for showing upload flows
  useEffect((): any => {
    if (showProbability > 0) {
      setShowNewUploadFlow(true);
      setShowExistingUploadFlow(false);
    } else if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow &&
      (status === 'ENHANCEMENT' || queryFlow) && !isCancel && !isPageNameDetail) {
      setShowNewUploadFlow(true);
      setShowExistingUploadFlow(false);
    } else {
      setShowNewUploadFlow(false);
      setShowExistingUploadFlow(true);
    }
  }, [showProbability]);

  useEffect((): any => {
    if (fileList?.length && finalMandatoryClassifications?.length) {
      const invalidFileIndex = fileList.findIndex(({ status: fStatus }: UploadFile): boolean => !fStatus);
      if (invalidFileIndex >= 0) {
        const fList = [...fileList];
        fList.splice(invalidFileIndex, 1);
        dispatch(setUploadedFiles([...fList]));
        return;
      }
      const nonAvailableClass = getNonAvailableClassification(finalMandatoryClassifications, fileList, nonAvailableClassification);
      setNonAvlclass(nonAvailableClass);
      dispatch(setNonAvailableClassification((isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0) ?
        finalMandatoryClassifications : nonAvailableClass));
      const isProcessInProgress = fileList.every(({ status: fStatus, extendedStatus }: any): boolean =>
        fStatus === UPLOAD_STATUS.uploading || extendedStatus === EXTENDED_STATUS.verifying);
      dispatch(setIsFileProcessInProgress(isProcessInProgress));
    } else {
      dispatch(setNonAvailableClassification([]));
      dispatch(setIsFileProcessInProgress(false));
    }
    calculatePercent(fileList);
    mounted.current = true;
    return (): boolean => (mounted.current = false);
  }, [fileList, finalMandatoryClassifications, showProbability]);

  const isBuddhimedAllowed = (fileInfo: any): boolean => {
    let isAllowed = false;
    if (callBuddhimed) {
      isAllowed = JSON.parse(isDCAllowed || '{}')?.[status || 'NEWADMISSION'];
    } else {
      isAllowed = false;
    }
    return isAllowed;
  };
  const draggerActions = {
    fileList,
    name: 'file',
    data: { payerId, hospActionId },
    multiple: true,
    action: GLOBAL_URL.CRM_BASE_URL + 'Provider/File/Upload',
    // headers: { accessToken: appDetail.getAccessToken() },
    withCredentials: true,
    openFileDialogOnClick: { openFileDialogOnClick },
    beforeUpload: (event: any): any => hisFileBeforeUpload(event, payer, maximumFileSizeAllowed, nextStatus,
      setFileErrorMessage, setIsValidFile, isValidFile),
    onChange: (fileInfo: UploadChangeParam<any>): void => {
      setErrMsgFromDeleteClaim('');
      const { file: { response, name, status: fileStatus, existingRecord, uid: currFileUid }, event, fileList: fList } = fileInfo;
      if (fileStatus === UPLOAD_STATUS.done) {
        const { isSuccess, uploadedDetails, errors, errorMessage } = response;
        if (!existingRecord && isSuccess && uploadedDetails && uploadedDetails.length) {
          setFileErrorMessage('');
          const guid = getValue(response, 'uploadedDetails[0].fileGuid');
          const findFile = fList.find((file: UploadFile): boolean => {
            const fileGUID = getValue(file, 'response.uploadedDetails[0].fileGuid');
            return fileGUID === guid;
          });

          if (currFileUid.indexOf('rc-upload') === -1) {
            const brokenFileIndex = fList?.findIndex((ele: any): boolean => ele?.uid === currFileUid);
            fList?.splice(brokenFileIndex, 1);
            dispatch(setUploadedFiles([...sortByUid(fList)]));
            centeredNotification(`Something went wrong while uploading ${name}! Please upload again`);
          }

          if (name === null) {
            const brokenFileIndex = fList?.findIndex((ele: any): boolean => ele?.uid === currFileUid);
            fList?.splice(brokenFileIndex, 1);
            dispatch(setUploadedFiles([...sortByUid(fList)]));
            centeredNotification('Please upload a file with name');
          }

          if (isBuddhimedAllowed(fileInfo)) {
            buddhimedReqQueue.push(findFile);
            setBuddhimedReqQueue(buddhimedReqQueue);
          }
        } else if (!isSuccess) {
          const brokenFileIndex = fList.findIndex((ele: any): boolean => ele?.uid === currFileUid);
          fList.splice(brokenFileIndex, 1);
          dispatch(setUploadedFiles([...sortByUid(fList)]));
          centeredNotification(errorMessage || errors?.join('\n') || COMMON_ERROR);
        }
      } else if (!fileStatus) {
        const perfectFileList = fList.filter((ele: any): boolean => ele?.percent);
        dispatch(setUploadedFiles([...sortByUid(perfectFileList)]));
      }

      if (!event?.percent && fileStatus !== 'error' && response?.isSuccess) {
        // Find the specific file to update based on some unique identifier (e.g., uid)
        const updatedFileList = fList?.map((element: any): any => {
          element['claimStatus'] = element['claimStatus'] ? element['claimStatus'] : NEW_UPLOAD_STATUS;
          if (element?.uid === currFileUid) { // condition to target the specific file
            element['uploadedOn'] = getISTDateWithTimeSeconds(new Date()); // Apply timestamp only to the matching file
          }
          return element; // Return the updated element
        });
        dispatch(setUploadedFiles([...sortByUid(updatedFileList)]));
        const flowName: any = claimDetails?.nextAllowStatus?.[0];

        if (flowName === 'ENHANCEMENT' && formTitle ===
          getCancelModalTitle(cancelActionProperty, FALL_BACK_CANCEL_MODAL_NAME)) {
          customGTMEvent({
            event: 'Upload Cancellation Documents',
            flow: formTitle,
          });
        }

        if (flowName === 'SUBMITINFO') {
          customGTMEvent({
            event: 'Upload Query Documents',
          });
        }
      }
    },
  };

  useEffect((): any => {
    if ((isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0
      && !uploadedFiles?.length) || form.getFieldValue('selectedOldFile')?.length > 0) {
      dispatch(setNonAvailableClassification(finalMandatoryClassifications));
    }
  }, [uploadedFiles, finalMandatoryClassifications, form.getFieldValue('selectedOldFile')]);

  useEffect((): any => {
    const notMatchingObjects = finalMandatoryClassifications?.filter((finalItem: any): any => {
      // Checking if the questionType is not present in newObject
      return nonAvlclass?.some((newItem: any): any => newItem?.questionType === finalItem?.questionType);
    });
    if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && notMatchingObjects?.length && showProbability > 0) {
      notMatchingObjects?.map((item: any): any => {
        if (item?.answer === 'yes') {
          // item.isClassified = 'yes';
          // item.fileName = 'checklistForm.pdf'; //here appending of files should happen
          item.isSelectFile = true;
        } else {
          item.isSelectFile = false;
        }
        return item;
      });
      if (nonAvailableClassification?.length) {
        nonAvailableClassification?.map((item: any): any => {
          if (item?.answer === 'yes' && !item?.isSelectFile) {
            item.isSelectFile = true;
          }
          return item;
        });
      }
      dispatch(setNonAvailableClassification(nonAvailableClassification));
      // for draft case mapping of discrepency
      if (isDraftSelected) {
        const formValue = form?.getFieldsValue();
        const dataArray = Array?.isArray(formValue) ? formValue : [formValue];
        const itemsWithValues = dataArray?.reduce((arrValue: any, dataItem: any): any => {
          // Iterate through each property in the dataItem
          Object?.entries(dataItem)?.forEach(([key, value]: any): any => {
            if (Array?.isArray(value)) {
              arrValue[key] = value;
            }
          });
          return arrValue;
        }, {});
        const updatedNonAvailableClassification = nonAvailableClassification?.map((obj: any): any => {
          const updatedObj = { ...obj };
          Object?.keys(itemsWithValues)?.forEach((key: any): any => {
            const valuesToMatch = itemsWithValues[key];
            // Check if the current object has a matching key and value
            if (valuesToMatch?.some((value: any): any => obj?.questionType && obj?.questionType.includes(value))) {
              updatedObj.answer = 'yes';
              updatedObj.isSelectFile = true;
            }
          });
          return updatedObj;
        });
        dispatch(setNonAvailableClassification(updatedNonAvailableClassification));
      }
    }
  }, [uploadedFiles, nonAvlclass]);

  useEffect((): void => {
    if (isComeFromSubmit) {
      form.validateFields().then((): void => {
        dispatch(setIsComeFromSubmit(false));
      });
    }
  }, [isComeFromSubmit]);

  const calculatePercent = (fList: UploadFile[]): void => {
    const percent: number = getFileUploadStatus<number>(fList, progress);
    dispatch(setPercent(percent));
  };

  const onRemove = (selectedUid: string, file?: any): void => {
    const index = [...fileList].findIndex(({ uid }: any): boolean => uid === selectedUid);
    const newIndex = [...(billAmountArray || [])].findIndex(({ fileId }: any): boolean => fileId === selectedUid);
    const deletedClassification = classificationArray?.filter(({ tempId }: any): boolean => tempId?.includes?.(selectedUid));
    if (deletedClassification && deletedClassification.length > 0) {
      deletedClassification.map((currElement: any): any => {
        currElement['isDeleted'] = true;
      });
    }
    fileList.splice(index, 1);
    dispatch(setUploadedFiles([...fileList]));
    if (classificationArray?.length) {
      dispatch(setClassificationArray([...classificationArray]));  // draft-case-bugfixed
    }
    billAmountArray.splice(newIndex, 1);
    dispatch(setbillAmountArray([...(billAmountArray || [])]));
    const { fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber, isDischargeCase: isDischargeCaseForm,
      settlementType, recieptNo, stayLength, patientPaidAmount, switchClick, courierAgencyName, dateOfDispatch,
      dateOfDelivery, podNo, handedOverTo,
      documentType, noOfFiles, documentSubmissionType, typeOfClaim, panNumber, aadharNo, dispatchDate,
      consignmentNumber, courierName, branch } = form?.getFieldsValue(['fileUploadRemark', 'claimedAmount', 'dateOfAdmission',
        'dateOfDischarge', 'inPatientNumber', 'isDischargeCase', 'recieptNo', 'settlementType', 'stayLength',
        'patientPaidAmount', 'switchClick', 'courierAgencyName', 'dateOfDispatch', 'dateOfDelivery', 'podNo', 'handedOverTo',
        'documentType', 'noOfFiles', 'documentSubmissionType', 'typeOfClaim', 'panNumber', 'aadharNo', 'dispatchDate', 'consignmentNumber',
        'courierName', 'branch']) || {};
    if (getIsPageNameNewAdmission(pathname) || mandatoryClassifications?.length || additionalMandatoryDocuments?.length || isSettlement) {
      form?.resetFields();
      nonAvailableClassification?.forEach((item: any): any => {
        item.isSelectFile = false;
      }); // when a file is removed, as we are clearing the questions , we are restting the file selection as well
      form?.setFieldsValue({
        fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber,
        isDischargeCase: isDischargeCaseForm, settlementType, recieptNo, stayLength, patientPaidAmount, switchClick,
        courierAgencyName, dateOfDispatch, dateOfDelivery, podNo, handedOverTo, documentType, noOfFiles, documentSubmissionType,
        typeOfClaim, panNumber, aadharNo, dispatchDate, consignmentNumber, courierName, branch,
      });
    }
    if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0 && nonAvailableClassification?.length) {
      const updatedClassification = nonAvailableClassification?.map((item: any): any => {
        if (uploadedFiles?.length) {
          if (file?.['fileType']?.[0] === item?.questionType) {
            return {
              ...item,
              answer: 'no',
              isSelectFile: false,
            };
          } else {
            const fileMappings = {
              'kyc': 'Patients ID Proof',
              'claim_form': 'Pre-auth/claim form',
              'bill': 'Estimated bill as per agreed tariff (as applicable)',
              'declaration_form': 'Declaration form/GIPSA certificate',
              'discharge_summary': 'Discharge Summary',
            };
            const fileType = file?.['fileType'];
            for (const [fileTypeKey, questionType] of Object?.entries(fileMappings)) {
              if (fileType?.includes(fileTypeKey) && item?.questionType === questionType) {
                return {
                  ...item,
                  answer: 'no',
                  isSelectFile: false,
                };
              }
            }
            return item;
          }
        } else {
          if (uploadedFiles?.length === 0) {
            return {
              ...item,
              answer: 'no',
              isSelectFile: false,
            };
          }
        }
        return item;
      });
      dispatch(setFinalMandatoryClassifications(updatedClassification));
      dispatch(setNonAvailableClassification(updatedClassification));
    }
    setFileErrorMessage('');
  };

  const draggerItemRender = (): null => null;

  const onChangeQuestion = (event: any, index: number): void => {
    nonAvailableClassification[index]['isSelectFile'] = (event?.target?.value === 'Yes' ||
      showProbability > 0 && event?.target?.checked === true);
    nonAvailableClassification[index]['answer'] = event?.target?.checked === false && 'no';
    dispatch(setNonAvailableClassification([...nonAvailableClassification]));
    if (event?.target?.value === 'No') {
      nonAvailableClassification[index]['attemptId'] = nonAvailableClassification[index]['attemptId'] + 1;
      dispatch(setNonAvailableClassification([...nonAvailableClassification]));
      document.getElementById('dragger')?.click();
      form.setFieldsValue({
        [nonAvailableClassification[index]['questionText']]: undefined,
      });
    }
  };

  const setFinalAnswer = (eventType: string, event: any, classificationObj: any, index: number): void => {
    const { questionText, questionType } = classificationObj;
    if (eventType === 'RADIO_CHANGE') {
      if (event?.target?.value === 'No') {
        const selectedQue = classificationArray?.filter((currClassification: any): boolean =>
          currClassification.questionType === questionType);
        selectedQue.map((ele: any): any => {
          ele['answer'] = 'no';
          ele['discrepancy'] = false;
          return ele;
        });
        dispatch(setClassificationArray([...classificationArray]));
        dispatch(setbillAmountArray([...billAmountArray]));
        onChangeQuestion(event, index);
      } else {
        onChangeQuestion(event, index);
        if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0) {
          if (event?.target?.checked) {
            classificationObj.answer = 'yes';
          } else {
            classificationObj.answer = 'no';
          }
          dispatch(setNonAvailableClassification([...nonAvailableClassification]));
        }
      }
    } else {
      const alreadySelectedQue = classificationArray?.find(({ questionType: currQueType, answer }: any): boolean =>
        (currQueType === questionType && answer === 'yes'));
      if (alreadySelectedQue) {
        alreadySelectedQue.answer = null;
      }
      const selectedClassification = classificationArray?.find((classification: any): boolean =>
        classification.tempId === `${event}${questionType}`);
      const selectedAnswer = form.getFieldsValue([questionText])[questionText];
      classificationObj['answer'] = String(selectedAnswer).toLowerCase();
      dispatch(setNonAvailableClassification([...nonAvailableClassification]));

      if (selectedClassification) {
        selectedClassification['answer'] = String(selectedAnswer).toLowerCase();
        selectedClassification['discrepancy'] = true;
        selectedClassification['answerOn'] = moment.default().format();
        selectedClassification['questionText'] = questionText;
        selectedClassification['questionType'] = questionType;
        dispatch(setClassificationArray([...classificationArray]));
      }
    }
  };

  let filesGroupByStatus = fileList.reduce((result: any, currentElement: any): any => {
    result[currentElement?.claimStatus] = [...result[currentElement?.claimStatus] || [], currentElement];
    return result;
  }, {});

  if (!showPreviouslyAddedFiles && filesGroupByStatus) {
    filesGroupByStatus = filesGroupByStatus[NEW_UPLOAD_STATUS] ? { [NEW_UPLOAD_STATUS]: filesGroupByStatus[NEW_UPLOAD_STATUS] } : {};
  }

  const alreadyUploadedFiles = (): any => {
    const temp = filesGroupByStatus;
    delete temp[NEW_UPLOAD_STATUS];
    delete temp[HIS_UPLOAD_STATUS];
    return temp;
  };

  if (filesGroupByStatus[NEW_UPLOAD_STATUS]) {
    const temp = filesGroupByStatus[NEW_UPLOAD_STATUS];
    delete filesGroupByStatus[NEW_UPLOAD_STATUS];
    filesGroupByStatus = {
      [NEW_UPLOAD_STATUS]: temp,
      ...filesGroupByStatus,
    };
  }

  const fileNameList = (): any => {
    const uploadedfiles = (fileList || [])
      .filter((file: any): boolean =>
        getValue(file, 'response.uploadedDetails.length') &&
        !file.existingRecord &&
        !ALLOWED_FILE_EXTENSIONS.BUDDHIMED_CALL_RESTRICT_TYPES.includes(file?.type),
      ).map(({ name, uid }: UploadFile): any => ({ name, value: uid }));

    const selectedOldFiles = (form.getFieldValue('selectedOldFile') || [])
      .filter((file: any): boolean =>
        getValue(file, 'response.uploadedDetails.length') &&
        !ALLOWED_FILE_EXTENSIONS.BUDDHIMED_CALL_RESTRICT_TYPES.includes(file?.type),
      ).map(({ name, uid }: UploadFile): any => ({ name, value: uid }));
    return (isSettlement ? [...selectedOldFiles, ...uploadedfiles] : uploadedfiles);
  };

  const onChange = (ev: any): any => {
    defaultTimeline.remarks[getPrefixforRemark(isDischargeContestCTA)] = ev.target.value;
    dispatch(updateDefaultTimeline(defaultTimeline));
  };

  const setFileId = (): void => {
    dispatch(downloadDocumentGuids([]));
    if (!isNewAdmissionPage) {
      fileList?.map((ele: any, index: number): any => {
        downloadDocumentGuidList?.push(ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
          if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
            downloadDocumentGuidList?.push(element?.fileGuid);
          }
        }));
      });
      dispatch(downloadDocumentGuids(downloadDocumentGuidList));
    }
  };
  const commonDetail = { form: admissionForm };

  const onClickDownloadAll = (): any => {
    setFileId();
    dispatch(actions.submitAdmissions({ downloadFiles }));
  };
  const onClickPrintAll = (): any => {
    setFileId();
    const payload = {};
    setpdfPreview(true);
    dispatch(printClaimPDF(payload, getPDFViewer));
  };
  const getPDFViewer = (data: any): void => {
    setTestPdf(data);
    const { fileName, isSuccess, fileBytes } = data || {};
    const byteSize = (new Blob([fileBytes]).size) / 1000000;
    if (isSuccess && byteSize < 2) {
      // Get MIME type based on file extension
      const mimeType = getMimeTypeFromExtension(fileName);

      setTestPdf('data:' + mimeType + ';base64,' + fileBytes);
      centeredNotification(`${fileName} start previewing...`, 'success');
    } else {
      centeredNotification(`${fileName} too large, couldn't Preview File `, 'error');
    }
  };

  const onModalCancel = (): any => {
    setTestPdf('');
    setpdfPreview(false);
  };
  const downloadFiles = (data: any): any => {
    const { fileName, isSuccess, errors = [] } = data || {};
    if (isSuccess) {
      centeredNotification(`${fileName} start downloading...`, 'success');
    } else {
      centeredNotification(errors.join(',\n'));
    }
  };
  const changeToUpper = (): void => {
    form.setFields([
      {
        name: 'panNumber',
        value: (form?.getFieldValue('panNumber') || '').toUpperCase(),
      },
    ]);
    dispatch(setPanField(form?.getFieldValue('panNumber')));

  };

  const handleCheckboxChange = (checkedValues: any): any => {
    setCheckedList(checkedValues);
  };

  const handleOnChangeQuestion = (
    event: any,
    classification: any,
    index: any,
  ): void => {
    setFinalAnswer('RADIO_CHANGE', event, classification, index);
    customGTMEvent({
      event: event?.target?.value ?? 'NA',
    });
  };

  const uploadedDocs = fileList?.reduce((result: any, item: any): any => {
    if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && item?.claimStatus !== 'New uploads') {
      if (!result?.[item?.claimStatus]) {
        result[item.claimStatus] = [];
      }
      result?.[item?.claimStatus]?.push(item);
    }
    return result;
  }, {});

  const getUploadContainerClass = (): string => {
    const hasNewUploads = filesGroupByStatus[NEW_UPLOAD_STATUS]?.length > 0;

    if (hasNewUploads) {
      if (isCancel) { return 'HIS-uploaded-docs-cancel'; }
      if (isCashlessSubmit) { return 'HIS-uploaded-docs-settlment'; }
      if (!showExistingUploadFlow && showNewUploadFlow) { return 'HIS-uploaded-docs HIS-uploaded-docs-other-flow'; }
      return isDCAllowed === null ? 'HIS-uploaded-docs' : `HIS-uploaded-docs`;
    } else {
      if (isCancel) { return 'HIS-flow-upload-width-cancel'; }
      if (isCashlessSubmit) { return 'HIS-flow-upload-width-settlement'; }
      return 'HIS-flow-upload-width';
    }
  };

  const getFileCountsByCategory = (filesObject: any): any => {
    return Object?.values(filesObject)?.reduce((total: any, files: any): any => total + (files?.length || 0), 0);
  };

  const renderPanNumberInputField = (): JSX.Element => (
    <FormTextInput
      detail={{
        ...commonDetail,
        key: 'panNumber',
        suffixTestId: 'form',
        onChange: changeToUpper,
        required: panMandatory,
        rules: [panValidationUpload],
        onFocus: (): void => handleUserFocus('panNumber', setInputStates, true),
        onBlur: (): void => handleUserFocus('panNumber', setInputStates, false),
        isShowSuggestedValue: inputStates?.panNumber?.isShowSuggestedValue,
      }}
    />
  );

  return (
    <div>
      { /* for existing flow */}
      {
        ((!isPageNameDetail || isCancel)) &&
        <p className={(isQueryFlow) ? payer?.isOnMailPayer ? 'document-text-his-query' : 'document-text-his-query-normal-payer' :
          isCancel ? 'document-text-his-cancel' : isCashlessSubmit ? 'document-text-his-settlement' : 'document-text-his'}>
          <span className="his-asterisk">*</span>Please upload these documents &nbsp;
          {documentsTobeSubmitted?.length ? documentsTobeSubmitted : fileTextMessage}</p>
      }
      {(!isPageNameDetail || isCancel) ? filesGroupByStatus[NEW_UPLOAD_STATUS]?.length || selectedFiles?.length ?
        <FileCount fileCount={numberOfFilesLimit}
          fileLimit={fileSizeForNextStatus ?? MAX_FILE_LIMIT_COUNT}
          uploadedFiles={filesGroupByStatus[NEW_UPLOAD_STATUS]?.length}
          previousFiles={showPreviouslyAddedFiles} fileList={fileList} selectedFiles={selectedFiles}
          payerWiseFileSize={totalFileSizeInNumber} /> :
        <NonHisFileCountHeader fileCount={numberOfFilesLimit} minFileCount={getMinFileCount(payer, nextStatus)}
          fileLimit={fileSizeForNextStatus ?? MAX_FILE_LIMIT_COUNT}
          uploadedFiles={filesGroupByStatus[NEW_UPLOAD_STATUS]?.length}
          previousFiles={showPreviouslyAddedFiles} fileList={fileList} payerWiseFileSize={totalFileSizeInNumber} /> : <></>}
      {showExistingUploadFlow && !showNewUploadFlow ?
        <div>
          <Row gutter={GUTTOR_SPACE} className={`${getIsPageNameDetail(pathname) ? 'detail-page-modal-non-his' : ''} HIS-cont-uploaded-files`}>

            <Col md={24} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
              {(!isPageNameDetail || isCancel) && <div className="scan-header-text">
                {filesGroupByStatus[NEW_UPLOAD_STATUS]?.length && <span className="HIS-upload-scan-text font-family-open-sans available-text">Scan and Upload Documents</span>}
                {filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? <div className="file-format-text file-format-no-top justify-end">
                  <span className={`file-upload-text his-file-count his-flex-cont`}>
                    <p className="file-note file-note-text HIS-File-Size-text">File format needs to be <span className="file-type">
                      {payer?.allowedFileTypes?.length > 0
                        ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                          ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                          : ALLOWED_FILE_EXTENSIONS.LABEL
                        : ALLOWED_FILE_EXTENSIONS.LABEL}</span></p>
                  </span>
                </div> : <></>}
              </div>}
              <div className={getUploadContainerClass()}>
                {(!isPageNameDetail || isCancel) &&
                  <Dragger
                    {...draggerActions}
                    itemRender={draggerItemRender}
                    id="dragger"
                    className={`file-upload-dragger ${!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? 'upload-width' : ''}`}
                    data-testid="dropzone"
                    openFileDialogOnClick={true}
                  >
                    <div>
                      {(!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length) ? (
                        <div className="flex flex-element flex-row dragger-item">
                          <div className="flex-element flex-col justify-center items-center w-90">
                            <b className="ant-upload-text his-file-upload-text"> Drag & Drop your file(s) here.
                            </b>
                            <p className="ant-upload-hint w-90">
                              <span className="allowed-files">File format needs to be</span> <span className="allowed-file-type">
                                {payer?.allowedFileTypes?.length > 0
                                  ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                                    ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                                    : ALLOWED_FILE_EXTENSIONS.LABEL
                                  : ALLOWED_FILE_EXTENSIONS.LABEL}
                              </span>
                            </p>
                            <p className="file-upload-text his-file-count-dragger">
                              *File size cannot exceed {fileSizeForNextStatus ?
                                `${fileSize[nextStatus]} MB` : `${MAX_FILE_LIMIT_COUNT} MB`}
                            </p>
                          </div>
                        </div>
                      ) : (
                        filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? (
                          <div className="his-file-container file-upload-HIS"
                            onClick={(event: any): any => {
                              event?.preventDefault();
                              event?.stopPropagation();
                            }}>
                            {/* <div className="new-documents-upload-header">Uploaded Documents</div> */}
                            <Row gutter={GUTTOR_SPACE} className="headers header-font row-item">
                              <Col md={6}><strong>Document</strong></Col>
                              <Col md={6}><strong>Uploaded on</strong></Col>
                              <Col md={4}><strong>Size</strong></Col>
                              <Col md={5}><strong>Document Type</strong></Col>
                              <Col md={3} className="padding-for-remove"><strong>Remove</strong></Col>
                            </Row>
                            {
                              filesGroupByStatus[NEW_UPLOAD_STATUS]?.map
                                ((file: UploadFile | any, index: number):
                                  ReactElement | null =>
                                  <NonHisBuddhiMedUploadListItem file={file} key={file.uid} index={index}
                                    onRemove={onRemove}
                                    fileListLength={filesGroupByStatus[NEW_UPLOAD_STATUS].length}
                                    newUploads={false} filesGroupByStatus={filesGroupByStatus}
                                    previousFiles={showPreviouslyAddedFiles}
                                    fileList={fileList} />)
                            }
                          </div>
                        ) : null
                      )}
                    </div>

                    <div className="flex flex-element flex-row justify-center">
                      <div className="flex-element justify-center items-center non-his-mr-10">
                        {!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? (
                          <Button
                            className="primary-btn"
                          >
                            <Plus_Icon />  <span className="add-btn-text">Add / Upload more files</span>
                          </Button>
                        ) : (
                          <Button
                            className="secondary-btn"
                          >
                            <Add_Plus_Icon /> <span className="add-more-btn-text">Add More</span>
                          </Button>
                        )}
                      </div>
                    </div>
                  </Dragger>}
                {(shortName === 'SHAI' && isPageNameDetail) ||
                  (!isPageNameDetail && process.env.REACT_APP_IS_PAN_CARD_DETAILS_ENABLED === 'true') &&
                  <Row className="margin-pan-card">
                    {optionalReq > 0 &&
                      <Divider className="margin-pan-card" />}
                    {renderPanNumberInputField()}
                    {optionalReq > 0 &&
                      <Col md={2} className="his-toolTip">
                        <Tooltip title={`${payer.name} ${PAN_MANDATORY}`}
                          overlayInnerStyle={{ width: '552px' }}>
                          <Informa />
                        </Tooltip>
                      </Col>
                    }
                    {optionalReq > 0 &&
                      <Divider className="margin-pan-card" />}
                  </Row>
                }
                {isPageNameDetail &&
                  <Row gutter={GUTTOR_SPACE} className="justify-end">
                    <Col>
                      <Button type="text" className="button-style" onClick={(): any => onClickPrintAll()}>
                        Print All</Button>
                      <Button type="text" className="button-style" onClick={(): any => onClickDownloadAll()}>
                        Download All</Button>
                    </Col>
                  </Row>
                }
              </div>
            </Col>
          </Row>
          <InformationSection />
          {
            isInitialSettlement && oldDocsAllowed ?
              <FormSwitch detail={{
                key: 'includeOldDocuments',
                label: INCLUDE_OLD_DOCS_LABEL,
                isSwitch: true,
                size: 24,
                hideToogleValue: true,
                isToggleBesideLabel: true,
              }} /> : null
          }
          {(!isPageNameDetail || isCancel) ? Object?.keys(alreadyUploadedFiles())?.length > 0 && <>
            <div className="old-documents-header my-sm-0 avl-docs-m-top-12">
              {`Available Documents (${getFileCountsByCategory(alreadyUploadedFiles())})`}</div>
            <Collapse className="my-sm-0 avl-docs-m-bottom-12" expandIconPosition="right" defaultActiveKey={['1']}>
              <Collapse.Panel header="Provider Documents" key="payer">
                {Object?.keys(alreadyUploadedFiles())?.length ?
                  <Row gutter={GUTTOR_SPACE} className="mb-sm">
                    <Col md={6}><strong>Documents</strong></Col>
                    <Col md={6}><strong>Uploaded on</strong></Col>
                    <Col md={4}><strong>Status</strong></Col>
                    <Col md={5}><strong>Document type</strong></Col>
                    <Col md={3}><strong>Select to Submit</strong></Col>
                  </Row> : null}
                {Object?.keys(alreadyUploadedFiles() || {})?.map((statusKey: string): any => (
                  statusKey !== NEW_UPLOAD_STATUS &&
                  <div key={statusKey + Date.now()}>
                    <Text type="secondary">{statusKey}</Text>
                    {alreadyUploadedFiles()[statusKey]?.map((file: UploadFile | any, index: number):
                      ReactElement | null => <HISAvailableUploadListItem file={file} key={file?.uid}
                        index={index} onRemove={onRemove}
                        fileListLength={alreadyUploadedFiles()[statusKey]?.length}
                        newUploads={false} isHISFlow={true} selectionAllowed={true}
                        form={form} numberOfFilesLimit={numberOfFilesLimit}
                        updateErrorMessage={setFileErrorMessage} />)}
                  </div>
                ))}
              </Collapse.Panel>
            </Collapse></> :
            Object?.keys(alreadyUploadedFiles())?.length > 0 && <>
              {Object?.keys(alreadyUploadedFiles())?.length ?
                <Row gutter={GUTTOR_SPACE} className="mb-sm">
                  <Col md={6}><strong>Documents</strong></Col>
                  <Col md={6}><strong>Uploaded on</strong></Col>
                  <Col md={4}><strong>Status</strong></Col>
                  <Col md={5}><strong>Document type</strong></Col>
                  <Col md={3}><strong>Remove</strong></Col>
                </Row> : null}
              {Object?.keys(alreadyUploadedFiles() || {})?.map((statusKey: string): any => (
                statusKey !== NEW_UPLOAD_STATUS &&
                <div key={statusKey + Date.now()}>
                  <Text type="secondary">{statusKey}</Text>
                  {alreadyUploadedFiles()[statusKey]?.map((file: UploadFile | any, index: number):
                    ReactElement | null => <NonHisBuddhiMedUploadListItem file={file} key={file.uid} index={index}
                      onRemove={onRemove} fileListLength={alreadyUploadedFiles()[statusKey].length}
                      newUploads={false} showStatus={getIsPageNameDetail(pathname) || isCancel} />)}
                </div>
              ))}
            </>

          }
          <div>
            <Row gutter={GUTTOR_SPACE} className="classification-items">
              {
                !isFileProcessInProgress && fileNameList().length > 0 ?
                  nonAvailableClassification?.map((classification: any, index: number): ReactElement => {
                    const { questionType } = classification;
                    return <Col md={24} key={index} className="col-questions"><HisDescrepencyQuestion
                      key={questionType}
                      classification={classification}
                      onChangeQuestion={(event: any): any =>
                        setFinalAnswer('RADIO_CHANGE', event, classification, index)}
                      setFinalAnswer={(event: any): any => setFinalAnswer('OPTION_CHANGE', event, classification, -1)}
                      fileNames={fileNameList()} buddhimedForm={form} /> </Col>;
                  })
                  : null
              }
            </Row>
          </div>
        </div>
        :
        <>
          <div>
            <InformationSection />
            {isInitialSettlement && !oldDocsAllowed ?
              <FormSwitch detail={{
                key: 'includeOldDocuments',
                label: INCLUDE_OLD_DOCS_LABEL,
                isSwitch: true,
                size: 24,
                hideToogleValue: true,
                isToggleBesideLabel: true,
              }} /> : null}

            <div>
              {(!isPageNameDetail || isCancel) && <div className="scan-header-text">
                {filesGroupByStatus[NEW_UPLOAD_STATUS]?.length && <span className="HIS-upload-scan-text font-family-open-sans available-text">Scan and Upload Documents</span>}
                {filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? <div className="file-format-text file-format-no-top justify-end">
                  <span className={`file-upload-text his-file-count his-flex-cont`}>
                    <p className="file-note file-note-text HIS-File-Size-text">File format needs to be <span className="file-type">
                      {payer?.allowedFileTypes?.length > 0
                        ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                          ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                          : ALLOWED_FILE_EXTENSIONS.LABEL
                        : ALLOWED_FILE_EXTENSIONS.LABEL}</span></p>
                  </span>
                </div> : <></>}
              </div>}
              <div className={`${getUploadContainerClass()} ${(!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length && selectedFiles?.length) ? 'upload-container-document' : ''}`}>
                {(!isPageNameDetail || isCancel) &&
                  <Dragger
                    {...draggerActions}
                    itemRender={draggerItemRender}
                    id="dragger"
                    className={`file-upload-dragger ${!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? 'upload-width' : ''}`}
                    data-testid="dropzone"
                    openFileDialogOnClick={true}
                  >
                    <div>
                      {(!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length) ? (
                        <div className="flex flex-element flex-row dragger-item">
                          <div className="flex-element flex-col justify-center items-center w-90">
                            <b className="ant-upload-text his-file-upload-text"> Drag & Drop your file(s) here.
                            </b>
                            <p className="ant-upload-hint w-90">
                              <span className="allowed-files">File format needs to be</span> <span className="allowed-file-type">
                                {payer?.allowedFileTypes?.length > 0
                                  ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                                    ? JSON.parse(payer?.allowedFileTypes || '{}')?.[nextStatus]
                                    : ALLOWED_FILE_EXTENSIONS.LABEL
                                  : ALLOWED_FILE_EXTENSIONS.LABEL}
                              </span>
                            </p>
                            <p className="file-upload-text his-file-count-dragger">
                              *File size cannot exceed {fileSizeForNextStatus ?
                                `${fileSize[nextStatus]} MB` : `${MAX_FILE_LIMIT_COUNT} MB`}
                            </p>
                          </div>
                        </div>
                      ) : (
                        filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? (
                          <div className="his-file-container file-upload-HIS"
                            onClick={(event: any): any => {
                              event?.preventDefault();
                              event?.stopPropagation();
                            }}>
                            {/* <div className="new-documents-upload-header">Uploaded Documents</div> */}
                            <Row gutter={GUTTOR_SPACE} className="headers header-font row-item">
                              <Col md={6}><strong>Document</strong></Col>
                              <Col md={6}><strong>Uploaded on</strong></Col>
                              <Col md={4}><strong>Size</strong></Col>
                              <Col md={5}><strong>Document Type</strong></Col>
                              <Col md={3} className="padding-for-remove"><strong>Remove</strong></Col>
                            </Row>
                            {
                              filesGroupByStatus[NEW_UPLOAD_STATUS]?.map
                                ((file: UploadFile | any, index: number):
                                  ReactElement | null =>
                                  <NonHisBuddhiMedUploadListItem file={file} key={file.uid} index={index}
                                    onRemove={onRemove}
                                    fileListLength={filesGroupByStatus[NEW_UPLOAD_STATUS].length}
                                    newUploads={false} filesGroupByStatus={filesGroupByStatus}
                                    previousFiles={showPreviouslyAddedFiles}
                                    fileList={fileList} />)
                            }
                          </div>
                        ) : null
                      )}
                    </div>

                    <div className="flex flex-element flex-row justify-center">
                      <div className="flex-element justify-center items-center non-his-mr-10">
                        {!filesGroupByStatus[NEW_UPLOAD_STATUS]?.length ? (
                          <Button
                            className="primary-btn"
                          >
                            + Add/Upload more files
                          </Button>
                        ) : (
                          <Button
                            className="secondary-btn"
                          >
                            + Add More
                          </Button>
                        )}
                      </div>
                    </div>
                  </Dragger>}
                {!isPageNameDetail && process.env.REACT_APP_IS_PAN_CARD_DETAILS_ENABLED === 'true' &&
                  <Row className="margin-pan-card">
                    {optionalReq > 0 &&
                      <Divider className="margin-pan-card" />}
                    {renderPanNumberInputField()}
                    {optionalReq > 0 &&
                      <Col md={2} className="toolTip">
                        <Tooltip title={`${payer.name} ${PAN_MANDATORY}`}
                          overlayInnerStyle={{ width: '552px' }}>
                          <Informa />
                        </Tooltip>
                      </Col>}
                    {optionalReq > 0 &&
                      <Divider className="margin-pan-card" />}
                  </Row>}
                {isPageNameDetail &&
                  <Row gutter={GUTTOR_SPACE} className="margin-print-button">
                    <Col>
                      <Button type="text" className="button-style" onClick={(): any => onClickPrintAll()}>
                        Print All</Button>
                      <Button type="text" className="button-style" onClick={(): any => onClickDownloadAll()}>
                        Download All</Button>
                    </Col>
                  </Row>}
              </div>
            </div>
          </div>
          {/* // for approved docs for query and enhance */}
          <div>
            {Object?.keys?.(uploadedDocs)?.length ?
              <div className="upload-docs mt-12">
                <PanelCollapse
                  accordion={true}
                  expandIconPosition="right"
                  defaultActiveKey={['1']}
                  keyName="1"
                  header="Available Document"
                >
                  {fileList?.length ?
                    <Row gutter={GUTTOR_SPACE} className="mb-sm">
                      <Col md={6}><strong>Documents</strong></Col>
                      <Col md={6}><strong>Uploaded on</strong></Col>
                      <Col md={4}><strong>Status</strong></Col>
                      <Col md={5}><strong>Document type</strong></Col>
                      <Col md={3}><strong>Select to Resubmit</strong></Col>
                    </Row> : null}
                  {Object?.keys(uploadedDocs)?.map((statusKey: string): any => (
                    <div key={statusKey + Date.now()}>
                      <Text type="secondary">{statusKey}</Text>
                      {uploadedDocs[statusKey]?.sort((a: any, b: any): any => new Date(a?.createdDate).getTime()
                        - new Date(b?.createdDate)?.getTime())?.map((file: UploadFile | any, index: number):
                          ReactElement | null => (
                          <HISAvailableUploadListItem
                            file={file}
                            key={file.uid}
                            index={index}
                            onRemove={onRemove}
                            fileListLength={uploadedDocs[statusKey].length}
                            form={form}
                            showCheckbox={true}
                            showProgress={false}
                            selectionAllowed={true}
                            numberOfFilesLimit={numberOfFilesLimit}
                            updateErrorMessage={setFileErrorMessage} />
                        ))}
                    </div>

                  ))}
                </PanelCollapse>
              </div> : <></>}
          </div>
        </>
      }
      {(showProbability > 0) &&
        <p className="query-percent mt-12">
          There is {showProbability}% chance, you will receive queries in this claim
        </p>
      }
      {
        ((!isDischargeCase && isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow) && uploadedFiles?.length === 0
          && !isCancel && !claimDetails?.isEnhance && showProbability > 0) &&
        <><p>
          {FILE_UPLOAD_QUERY}
        </p>
          <div className="checklist">
            <ul>
              {finalMandatoryClassifications?.map((item: any, index: any): any => (
                <li key={index}>
                  {item?.questionType}
                  {(index < 3) && <span className="i-icon"><InformationIcon /></span>}
                </li>
              ))}
            </ul>
          </div></>}
      {(uploadedFiles?.length > 0 && showProbability > 0) &&
        <p dangerouslySetInnerHTML={{ __html: FILE_CHECKBOX_SELECTION }} />
      }
      {(isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0 && uploadedFiles?.length > 0) &&
        nonAvailableClassification?.map((classification: any, index: number): ReactElement => {
          const { questionType } = classification;
          return <DiscrepencyClassificationQuestion
            key={questionType}
            classification={classification}
            onChangeQuestion={(event: any): any => { handleOnChangeQuestion(event, classification, index); }}
            setFinalAnswer={(event: any): any => setFinalAnswer('OPTION_CHANGE', event, classification, -1)}
            fileNames={fileNameList()}
            onRemove={onRemove}
            form={form}
            handleCheckboxChange={handleCheckboxChange}
            showInfoIcon={!isDischargeCase}
            index={index}
            checkedList={checkedList} />;
        })
      }
      {
        ((isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && showProbability > 0 && !isDischargeCase) &&
          !isCancel && !claimDetails?.isEnhance && showProbability > 0) && <p className="info-icon-size"><span><InformationIcon />
          </span> Most asked documents in queries. Please upload these documents to reduce queries</p>
      }
      {
        appDetail.getIsInitialDischargeEnabledProvider() && isDaycareCase && isInitialDischargeEnabledPayer &&
        <div>
          <span className="standard-text-primary mb-sm ">{ABHI_INITIALDISCHARGE}</span>
        </div>
      }
      {
        (!remarkRemoved && !isSettlement) ?
          <Row gutter={GUTTOR_SPACE} className={(claimDetails?.showRemarksField && cancelFlow) ? 'cancelflow' : ''}>
            <FormTextArea detail={{
              ...commonDetail,
              key: 'fileUploadRemark',
              placeholder: getFlowName(isDischargeContestCTA),
              size: 24,
              onChange,
              disabled: false,
              isEditableInDetail: claimDetails?.showRemarksField,
              required: isRemarksFieldRequired('fileUploadRemark', formControlConfig, isCancel, nextStatus, isDischargeContestCTA),
              minLengthValue,
              maxLengthValue,
              fieldLengthValue,
            }}
            />
          </Row>
          : null
      }
      {fileErrorMessage && <div className="error-message error-text text-center error-text-bottom-12">{fileErrorMessage}</div>}

      <Modal
        visible={pdfPreview}
        onCancel={onModalCancel}
        footer={null}
        centered={true}
        width="1120px"
        bodyStyle={{ height: 750, width: 'auto' }}
        closeIcon={<CrossIcon />}
      >
        <Row className="overflow-x-scroll">
          <Col>
            <iframe src={testPdf} width="900" height="720" loading="lazy" />

          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default withRouter(BuddhiMedFileUpload);
